




























































import { Component, Vue, Prop } from 'vue-property-decorator'
import Partner from '@/components/public/Partner.vue'
import orderApi from '@/api/orderApi'
import moment from 'moment'
import ShowImg from '@/components/ui/ShowImg.vue'
import CountDown from '@/components/ui/CountDown.vue'
import userApi from '@/api/userApi'
import * as OSS from 'ali-oss'
import imgOrVideoShow from '@/components/public/imgOrVideoShow.vue'
/**
 * 订单详情
 */
@Component({
  components: {
    ShowImg,
    CountDown,
    Partner,
    imgOrVideoShow
  },
  filters: {
    formatYMD(value: any) {
      return moment(Number(value)).format('YYYY-MM-DD  HH:mm')
    },
    format(value: any) {
      return moment(Number(value)).format('YYYY-MM-DD')
    }
  }
})
export default class OrderDetails extends Vue {
  @Prop()
  public orderCode: string
  private orderStatus: number = 4
  private details: any = {}
  private goodsList: any = []
  public coloFlag:string ='red'
  public proviceData: any = {};
  public checkIndex:number = 0;
  public fileList:any =[];
  public previewVisible:boolean =false;
  public previewSrc:any='';
  public previewType:any='';
  // 通信秘钥信息
  protected accessKeyInfo: any = {}
  protected client: any = {}



  public mounted() {
    this.getOrderDetails()
    this.getStoreNum((res?:any)=>{
      orderApi.getStoreMaterial({
        id: res.stores[0].feedbackId
      }).then((res) => {
        if(res.code == 200){
          this.fileList=[];
          res.data.map((item?:any)=>{
            this.fileList.push({
              uid: item.feedbackMaterial.imgId,
              name: item.feedbackMaterial.path,
              path: this.getUrl(item.feedbackMaterial.path),
              thumbnail:this.getUrl(item.feedbackMaterial.thumbnail),
              type:item.feedbackMaterial.type,
            })
          })
          // this.proviceData=res.data[0];
        }
      })
    })
    this.getKeyInfo()
  }

  protected getOrderDetails() {
    orderApi.getOrderDetails({
      orderCode: this.$route.query.orderCode
    }).then((res) => {
      if (res.code === 200) {
        this.details = res.data
      }
    })
  }

  protected goBuy() {
    this.$router.push({ name: 'pay', query: { orderNo: this.$route.query.orderCode } })
  }


  // 获取省门店
  private getStoreNum(callback?:any) {
    orderApi.getStoreNum({
      orderCode: this.$route.query.orderCode
    }).then((res) => {
      if(res.code == 200){
        this.proviceData=res.data[0];
        if(callback){callback(res.data[0])}
      }
    })
  }

  protected getKeyInfo() {
    userApi.getStsAccessKeyInfo({}).then(res => {
      // console.log(res)
      this.accessKeyInfo = res.data
      this.client = new OSS({
        accessKeyId: this.accessKeyInfo.accessKeyId || '',
        accessKeySecret: this.accessKeyInfo.accessKeySecret || '',
        stsToken: this.accessKeyInfo.securityToken || '',
        // endpoint: this.accessKeyInfo.endpoint || '',
        bucket: this.accessKeyInfo.bucketName || '',
        region: 'oss-cn-beijing',
      })
    }, res => {
      // this.$Message.error(res.msg)
    })
  }

  public getUrl(n:any){
    return this.client.signatureUrl(n);
  }

  // const signatureUrl = this.client.signatureUrl(objectKey)

  // 点击门店获取数据
  public checkButton(item?:any,index?:any){
    console.log(item)
    this.checkIndex = index;
    orderApi.getStoreMaterial({
      id: item.feedbackId
    }).then((res) => {
      if(res.code == 200){
        this.fileList=[];
        res.data.map((item?:any)=>{
          this.fileList.push({
            uid: item.feedbackMaterial.imgId,
            name: item.feedbackMaterial.path,
            path: this.getUrl(item.feedbackMaterial.path),
            thumbnail:this.getUrl(item.feedbackMaterial.thumbnail),
            type:item.feedbackMaterial.type,
          })
        })
        this.getStoreNum();
        // this.proviceData=res.data[0];
      }
    })

  }

  public handleCancel () {
    this.previewVisible = false;
    const mm = document.getElementById("media");
    if(mm){
      (mm as any).pause();
    }
  }

  public handlePreview (file?:any) {
    this.previewSrc = file.path
    this.previewVisible = true
    this.previewType = file.type;
  }

}
